import { createTheme } from '@mui/material/styles';
import { colors } from '@mui/material';

const theme = createTheme({
    palette: {
        background: {
            dark: '#F4F6F8',
            default: '#F7F6F4',
        },
        primary: {
            main: '#ca0017',
            hover: '#ca001790',
        },
        secondary: {
            main: '#E5E3DB',
        },
        danger: {
            main: colors.red[500],
            light: colors.red[300],
        },
        success: {
            main: colors.green[500],
        },
        text: {
            primary: '#424242',
            secondary: '#ca0017',
            danger: '#ca0017',
        },
        typography: {
            fontFamily: 'Ubuntu',
        },
    },
    typography: {
        h1: {
            fontSize: '2rem',
            fontFamily: 'Ubuntu',
            textTransform: 'uppercase',
            color: '#424242',
        },
        h2: {
            fontSize: '1.5rem',
            fontFamily: 'Ubuntu',
            fontWeight: 800,
            color: '#424242',
        },
        h3: {
            fontSize: '1.2rem',
            fontFamily: 'Ubuntu',
            fontWeight: 800,
            color: '#424242',
        },
        h4: {
            fontSize: '1rem',
            fontFamily: 'Ubuntu',
            fontWeight: 800,
            color: '#424242',
        },
        h5: {
            fontSize: '1rem',
            fontFamily: 'Ubuntu',
            fontWeight: 800,
            color: '#ca0017',
        },
        body1: {
            fontFamily: 'Ubuntu',
            color: '#424242',
        },
        caption: {
            color: '#cacaca',
        },
        root: {
            '& a': {
                color: '#5e5e5e',
                textDecoration: 'none',
                transition: '0.5s',
                '&:hover': {
                    color: 'black',
                },
            },
        },
    },
    '& a': {
        color: 'black',
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1150,
            xl: 1920,
        },
    },
});

export default theme;
